import { getConsent } from "./consent";

const API = process.env.REACT_APP_BACKEND_URL;
const VID = "ct_vid";
const SID = "ct_sid";

const uid = () => (crypto.randomUUID ? crypto.randomUUID().replace(/-/g, "") : Math.random().toString(36).slice(2) + Date.now().toString(36));

export const getVisitorId = () => {
  let v = localStorage.getItem(VID);
  if (!v) { v = uid(); localStorage.setItem(VID, v); }
  return v;
};

export const getSessionId = () => {
  let s = sessionStorage.getItem(SID);
  if (!s) { s = uid(); sessionStorage.setItem(SID, s); }
  return s;
};

export function track(type, data = {}, { force = false } = {}) {
  if (!force && !getConsent().statistik) return;
  const body = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    type,
    path: window.location.pathname,
    referrer: document.referrer || "",
    screen_w: window.innerWidth,
    lang: navigator.language || "",
    ...data,
  };
  try {
    fetch(`${API}/api/analytics/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
  } catch (_) {}
}
